var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-list"},[_vm._l((_vm.categories),function(categoryID){return _c('span',{key:categoryID},[_vm._v(" "+_vm._s(_vm.categoriesWithoutLevelName[categoryID + ''].title)+" ")])}),_vm._v(" "+_vm._s(_vm.level)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }